<script setup lang="ts">
import type { NuxtError } from '#app'

// useSeoMeta({
//   title: 'Page not found',
//   description: 'We are sorry but this page could not be found.',
// })

const props = defineProps({
  error: {
    type: Object as PropType<NuxtError>,
    required: true,
  },
})

console.error(props.error)

useHead({
  htmlAttrs: {
    lang: 'en',
  },
  meta: [
    {
      name: 'viewport',
      content: 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no, viewport-fit=cover',
    },
  ],
})

const maximize = ref(false)
const toggleMaximize = () => {
  maximize.value = !maximize.value
}
provide('toggleMaximize', { maximize, toggleMaximize })
</script>

<template>
  <div>
    <NuxtLayout name="default">
      <UiPage padding>
        <UiCard
          :title="('Oops! Something went wrong')"
          :description="('We couldn\'t find the page you were looking for')"
        >
          <template #footer>
            <UiCardFooter>
              <UiButton
                color="primary"
                to="/"
              >
                {{ ('Go to Home') }}
              </UiButton>
            </UiCardFooter>
          </template>
        </UiCard>
      </UiPage>
    </NuxtLayout>
  </div>
</template>
